import { Component } from '@angular/core';
import { ShellConstant } from '@shell_components/constants/shellConstants';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  shellConstant = ShellConstant;
  year: number = Date.now();
}
